import { Navigate, useParams } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";

// Maps a record-detail resource to the menu key that grants access to it.
const RESOURCE_MENU = {
  leads: "/leads",
  projects: "/leads",
  property_search: "/leads",
  preconstruction: "/leads",
  construction: "/leads",
  closeout: "/leads",
  directory: "/leads",
  financials: "/leads",
  documents: "/leads",
  schedule: "/leads",
  opportunities: "/opportunities",
  campaigns: "/campaigns",
  contacts: "/contacts",
  trials: "/trials",
  customers: "/accounts",
  accounts: "/accounts",
  audiences: "/audiences",
  content_assets: "/content",
  tasks: "/tasks",
  automations: "/automations",
  integrations: "/integrations",
  appointments: "/calendar",
  prospects: "/lead-import",
};

function AccessDenied() {
  return (
    <div className="h-full w-full flex items-center justify-center p-8" data-testid="access-denied">
      <div className="max-w-md text-center">
        <div className="mx-auto mb-5 h-14 w-14 rounded-full bg-destructive/10 flex items-center justify-center">
          <ShieldAlert className="h-7 w-7 text-destructive" />
        </div>
        <h1 className="font-display text-2xl font-bold tracking-tight mb-2">Access denied</h1>
        <p className="text-sm text-muted-foreground mb-6">
          You don't have permission to view this page. Contact an administrator if you believe this is a mistake.
        </p>
        <Button onClick={() => (window.location.href = "/app")} data-testid="access-denied-home-btn">
          Back to Home
        </Button>
      </div>
    </div>
  );
}

export default function RouteGuard({ menuKey, adminOnly, children }) {
  const { user, menus, isAdmin, menusLoaded } = useAuth();
  const params = useParams();

  if (user === undefined || (user && !menusLoaded))
    return (
      <div className="h-screen w-full flex items-center justify-center text-muted-foreground" data-testid="auth-loading">
        Loading…
      </div>
    );
  if (user === null) return <Navigate to="/login" replace />;
  if (isAdmin) return children;
  if (adminOnly) return <AccessDenied />;

  let key = menuKey;
  if (menuKey === "record") key = RESOURCE_MENU[params.resource] || null;
  if (key && key !== "/" && !menus.includes(key)) return <AccessDenied />;

  return children;
}
